import React from 'react';
import { Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function TokenExpiredPage() {
  const navigate = useNavigate();

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 2 }}>Sessione scaduta</Typography>
      <Typography sx={{ mb: 2 }}>Il tuo accesso è scaduto. Effettua nuovamente il login.</Typography>
      <Button variant="contained" onClick={() => navigate('/login')}>Login</Button>
    </Container>
  );
}